module.exports = globalThis.__webpack_lazy_fm__.systemjs('@onviobr/dms-scan');